import React, { useImperativeHandle } from "react";
import * as environment from '../config/environment';
import ReCAPTCHA from "react-google-recaptcha";

const Recaptcha = React.forwardRef((props:any, ref) => {
    
    const captchaRef = React.useRef<ReCAPTCHA>(null);
    
    const handleSubmit = async () => {
        try {
            const token = await captchaRef.current?.executeAsync();
            return token;
        } catch (error) {
            console.error("reCAPTCHA Error:", error);
            props.changeHandleRecaptcha(false);
            return null;
        }
    };
    
    const reset =()=>{
        props.changeHandleRecaptcha(false);
        captchaRef.current?.reset();
    }

    const onChange = (token: any) => {
        if (token) {
            props.changeHandleRecaptcha(true);
        } else {
            props.changeHandleRecaptcha(false); 
        }
    }
    
    useImperativeHandle(ref, () => ({
        handleSubmit,
        reset
    }));
    return (
       <>
            <ReCAPTCHA  sitekey={environment.GOOGLE_RECAPTCHA_KEY} hl="tr" size="invisible" ref={captchaRef} onExpired ={reset}
                onChange={onChange} 
            />
       </> 
    );
  });

  export default Recaptcha;

